import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { useFetchAdUnitSizes } from './useFetchAdUnitSizes'
import RequiredCreativeSizesSkeleton from './RequiredCreativeSizesSkeleton'

import useStyles from './styles'
import {
  ENVIRONMENT_TYPE,
  environmentTypes
} from '../../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/fields'

const RequiredCreativeSizes = ({ isOpened, inventory }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { data, isLoading } = useFetchAdUnitSizes({
    isOpened,
    inventory
  })

  const filteredSizes = useMemo(() => {
    // exclude all Audio creative sizes from required creative. We do not support audio
    return data?.filter(item => !item.is_audio)
  }, [data])

  const videoSizes = useMemo(() => {
    return filteredSizes?.filter(item => item[ENVIRONMENT_TYPE] === environmentTypes.VIDEO_PLAYER) || []
  }, [filteredSizes])

  const displaySizes = useMemo(() => {
    return filteredSizes?.filter(item => item[ENVIRONMENT_TYPE] === environmentTypes.BROWSER) || []
  }, [filteredSizes])

  if (isLoading) {
    return <RequiredCreativeSizesSkeleton />
  }

  return (
    <div className={classes.requiredCreativeSizesContainer}>
      <h5 className={classes.title}>{t('Required creative sizes')}</h5>
      <div className={classes.videoAndImageRow}>
        {videoSizes.length > 0 && (
          <div className={classes.column}>
            <h6 className={classes.title}>{t('Video')}</h6>

            {videoSizes.map(item => (
              <div key={item.full_display_string}>{item.full_display_string}</div>
            ))}
          </div>
        )}

        {displaySizes.length > 0 && (
          <div className={classes.column}>
            <h6 className={classes.title}>{t('Image')}</h6>

            {displaySizes.map(item => (
              <div key={item.full_display_string}>{item.full_display_string}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

RequiredCreativeSizes.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  inventory: PropTypes.arrayOf(
    PropTypes.shape({
      network_code: PropTypes.number,
      placement_id: PropTypes.number,
      ad_unit_id: PropTypes.number,
      name: PropTypes.string,
      prices: PropTypes.shape({
        cpm: PropTypes.number,
        cpc: PropTypes.number,
        viewable_cpm: PropTypes.number
      })
    })
  ).isRequired
}

export default RequiredCreativeSizes
